import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "content-with-sidebar" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "carousel-wrapper" }
const _hoisted_5 = { class: "carousel-card" }
const _hoisted_6 = {
  key: 0,
  class: "carousel-image-wrapper"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "default-image"
}
const _hoisted_9 = { class: "carousel-content-overlay" }
const _hoisted_10 = { class: "carousel-content" }
const _hoisted_11 = { class: "carousel-title" }
const _hoisted_12 = { class: "carousel-description" }
const _hoisted_13 = { class: "carousel-meta" }
const _hoisted_14 = { class: "meta-item" }
const _hoisted_15 = { class: "meta-item" }
const _hoisted_16 = { class: "meta-item" }
const _hoisted_17 = { class: "meta-item" }
const _hoisted_18 = { class: "announcement-sidebar" }
const _hoisted_19 = { class: "announcement-card" }
const _hoisted_20 = { class: "announcement-header" }
const _hoisted_21 = { class: "announcement-count" }
const _hoisted_22 = { class: "announcement-list" }
const _hoisted_23 = { class: "announcement-title" }
const _hoisted_24 = { class: "announcement-preview" }
const _hoisted_25 = { class: "announcement-time" }
const _hoisted_26 = {
  key: 0,
  class: "no-announcements"
}
const _hoisted_27 = { class: "announcement-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Star = _resolveComponent("Star")!
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "dashboard-layout" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, { class: "dashboard-main" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "welcome-section" }, [
                  _createElementVNode("h2", null, "欢迎来到手工钩织社区"),
                  _createElementVNode("p", null, "发现最新最精彩的手工钩针作品")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_carousel, {
                    height: _ctx.carouselHeight,
                    "indicator-position": "outside",
                    autoplay: true,
                    interval: 5000,
                    arrow: "hover"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, {
                          key: post.id,
                          onClick: ($event: any) => (_ctx.goToPostDetail(post.id)),
                          class: "carousel-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              (post.coverImage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("img", {
                                      src: post.coverImage,
                                      alt: "帖子封面",
                                      class: "carousel-image"
                                    }, null, 8, _hoisted_7)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("i", { class: "crochet-placeholder-icon" }, "_hooks", -1),
                                    _createElementVNode("p", null, "暂无图片", -1)
                                  ]))])),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("h3", _hoisted_11, _toDisplayString(post.title), 1),
                                  _createElementVNode("p", _hoisted_12, _toDisplayString(post.content.substring(0, 50)) + _toDisplayString(post.content.length > 50 ? '...' : ''), 1),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_View)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(post.viewCount), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Star)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(post.likeCount), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Star)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(post.favoriteCount), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ChatLineRound)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(post.commentCount), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["height"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "📢 系统公告", -1)),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.topAnnouncements.length) + " 条", 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topAnnouncements, (announcement) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: announcement.id,
                        class: "announcement-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAnnouncementCenter()))
                      }, [
                        _createElementVNode("h4", _hoisted_23, _toDisplayString(announcement.title), 1),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(announcement.content.substring(0, 60)) + _toDisplayString(announcement.content.length > 60 ? '...' : ''), 1),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDate(announcement.publishTime)), 1)
                      ]))
                    }), 128)),
                    (_ctx.topAnnouncements.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("p", null, "暂无公告", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToAnnouncementCenter())),
                      disabled: _ctx.topAnnouncements.length === 0
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" 查看全部 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}